module.exports = __webpack_public_path__ + "img/infographic1.5af55962.png";